var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillBalloonChatMoreGy2 = function SvgFillBalloonChatMoreGy2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 62,
    fill: "none",
    viewBox: "0 0 73 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E6E9",
    d: "M13.736 32.506a1 1 0 0 1 1.673-.448l14.9 14.901a1 1 0 0 1-.448 1.673L9.506 54.086a1 1 0 0 1-1.225-1.224z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E6E9",
    d: "M40.5 55.5C58.45 55.5 73 43.188 73 28S58.45.5 40.5.5 8 12.812 8 28s14.55 27.5 32.5 27.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C8CED4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.334,
    cy: 29,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.667,
    cy: 29,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 29,
    r: 3.5
  }))));
};
export default SvgFillBalloonChatMoreGy2;